import React from 'react';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_ACCENT_DARK, COLOR_PRIMARY, DEVICES } from '../../const';
import { ArrowForwardRounded } from '@mui/icons-material';
import ChannelTalkService from '../../ChannelTalkService';

const Container = styled.div`
  background-image:	url("https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/sixth.jpg");
  background-size: cover;
  background-position: 52% 54%;
  position: relative;
  padding: 2rem;

  @media ${DEVICES.mobile} {
    padding: 60px 1rem;
  }

  @media ${DEVICES.tablet} {
    padding: 100px 1.5rem;
  }

  @media ${DEVICES.large} {
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  background-color: rgba(35, 46, 43, 0.7);
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const Inner = styled.div`

  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    margin: auto;
    padding: 2rem;
  }

  @media ${DEVICES.large} {
    max-width: 1200px;
  }
`;

const Content = styled.div`
  position: relative;
  text-align: center;
`;

const Heading = styled.div`
`;

const Title = styled.div`
  color: #fff;
  font-weight: 700;
  text-align: center;
  @media ${DEVICES.mobile} {
    font-size: 2rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.2rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 3rem;
  }
`;

const CardList = styled.div`
  display: flex;
  margin-top: 60px;
  flex-wrap: wrap;
  margin: 60px auto;
  width: 100%;

  @media ${DEVICES.mobile} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    flex-direction: row;
    justify-content: center;
  }

  @media ${DEVICES.laptop} {
  } 
`;

const Card = styled.div`
  background: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  border: 2px solid #fff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  padding: 2.5rem;
  text-align: center;
  margin: 1rem;

  @media ${DEVICES.mobile} {
    width: 300px;
  }

  @media ${DEVICES.tablet} {
    width: 280px;
    height: 250px;
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    height: 300px;
    width: 320px;
    font-size: 1.25rem;
  } 
`;

const CardTitle = styled.div`
  font-size: 1.5rem;
  color: ${COLOR_PRIMARY};
  font-weight: 700;
`;

const Description = styled.div`
  color: #fff;
  margin-top: 1.5rem;
`;

const Highlight = styled.div`
  color: #fff;
  font-weight: 700;
  margin-top: 60px;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
  }  
`;

const ContactButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

const ContactButton = styled.button`
  border-radius: 1rem;
  padding: 1rem 3rem;
  text-align: center;
  background-color: #fff;
  border: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1rem;

  @media ${DEVICES.mobile} {
    min-width: 200px;
  }

  @media ${DEVICES.tablet} {
    min-width: 200px;
  }

  @media ${DEVICES.laptop} {
    min-width: 300px;
  }

  &:hover {
    background-color: ${COLOR_PRIMARY};
  }
`;


export default function AboutSixthBanner() {

  const openChannelTalk = () => {
    ChannelTalkService.openChat();
  };

  return <Container>
    <ImageWrapper>
    </ImageWrapper>
    <Inner>
      <Content>
        <Title>
          캥거루짐의 다짐
        </Title>
        <CardList>
          <Card>
            <CardTitle>
              하나.
            </CardTitle>
            <Description>
              우리가 하는 일은 하나의 건강한 우주를 만들어가는 숭고하고 책임감있는 일이다.
            </Description>
          </Card>
          <Card>
            <CardTitle>
              둘.
            </CardTitle>
            <Description>
              나의 자식이라면 캥거루짐에 보낼까? 매순간 고민하고 행동한다.
            </Description>
          </Card>
          <Card>
            <CardTitle>
              셋.
            </CardTitle>
            <Description>
              선생님들의 휴식 여건과 대우는 최대한 보장한다.
            </Description>
          </Card>
        </CardList>
        <Highlight>
          하루하루 쌓여가는 아이들의 자존감과 <br />
          그를 뒷받침하는 신체 데이터를 확인해보세요.
        </Highlight>
        <ContactButtonWrapper>
          <ContactButton onClick={openChannelTalk}>
            수업 상담 및 문의하기
          </ContactButton>
        </ContactButtonWrapper>
      </Content>
    </Inner>
  </Container>
}
